import script from "./AuthorizationRepeatModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthorizationRepeatModal.vue?vue&type=script&setup=true&lang=js"

import "./AuthorizationRepeatModal.vue?vue&type=style&index=0&id=230deffc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-230deffc"]])

export default __exports__